import {ref} from 'vue'

import {defineStore} from 'pinia'

export const useWebShopStore = defineStore('webShopStore', () => {
    
    const products = ref([]);
    const productTypes = ref([])
    const categories = ref([])
    const nnidPlaceholder = ref('')
    const isOptima = ref(false)
    const domain = ref('')
    const officeData = ref({
        email: '',
        mobile: '',
    })
    const promoContent = ref('')
    const hasVueBookingWizard = ref(false)
    const primaryColor = ref('#777')
    
    const selectedProductTypeId = ref(null)
    const selectedCategoryId = ref(null)
    const selectedProduct = ref(null)
    const selectedCourse = ref(null)

    const selectProduct = (product) => {
        selectedProduct.value = {...product}
    }

    const selectCourse = (product, course) => {
        selectedProduct.value = {...product}
        selectedCourse.value = {...course}
    }

    const closeProduct = () => {
        selectedProduct.value = null;
        selectedCourse.value = null;
    }

    return {
        products,
        productTypes,
        categories,
        nnidPlaceholder,
        isOptima,
        domain,
        officeData,
        promoContent,
        hasVueBookingWizard,
        primaryColor,
        selectedProductTypeId,
        selectedCategoryId,
        selectedProduct,
        selectedCourse,

        // Methods
        selectProduct,
        selectCourse,
        closeProduct,
    }
})